module.exports = __webpack_public_path__ + "img/106.fb2a28a3.jpg";